import React from 'react'
import {handle} from '../events'
import {Image} from 'react-konva'
import * as Behaviours from 'alcumus-behaviours'

import useImage from 'use-image'
import {addGameObject} from '../system'

import planet1 from './moon_.png'
import planet2 from './planet_1.png'
import planet3 from './planet_2.png'
import {getState} from '../game-surface'

export const SPACE = 60000

const PLANETS = [planet1, planet2, planet3]

function Sprite(sprite, owner) {
    let result = function Sprite() {
        let [image] = useImage(sprite)
        return (image && <Image image={image}/>) || null
    }

    return result
}

Behaviours.register('planet', {
    initialize() {
        this.configure()
        handle('resetGame', this.configure.bind(this))
    },
    methods: {
        configure() {
            this.$.x = Math.random() * 2800 - 600
            this.$.y = -Math.random() * 700 - 4800
            this.$.scale = Math.random() * 1.1 + 0.5
            this.$.opacity = Math.max(
                0,
                Math.random() * 0.5 + 0.6 - (SPACE - getState().height) / SPACE
            )
            this.speed = (20 + Math.random() * 50) * 4
        },
        Update(dt) {
            this.$.y += dt * this.speed * getState().rocketSpeed
            if (this.$.y > 2500) {
                this.configure()
            }
        },
    },
})

handle('initializeGame', () => {
    for (let i = 0; i < 5; i++) {
        addGameObject(
            {z: -30},
            {
                planet: {},
                sprite: {
                    Sprite: Sprite(PLANETS[Math.floor(Math.random() * 6) % 3]),
                },
            }
        )
    }
})
